<div class="tag-statistic">
    <div *ngIf="_newTags.length === 0 && _removedTags.length === 0; else templateUpdatedTags">
        Nothing to update
    </div>
    <ng-template #templateUpdatedTags>
        <div *ngIf="_newTags.length > 0">
            <label>New tag(s) :</label>
            <ul class="pb-2">
                <li *ngFor="let tag of _newTags;">
                    {{ tag }}
                </li>
            </ul>
        </div>
        <div *ngIf="_removedTags.length > 0">
            <label>Removed tag(s) :</label>
            <ul class="pb-2">
                <li *ngFor="let tag of _removedTags;">
                    {{ tag }}
                </li>
            </ul>
        </div>
    </ng-template>
</div>